import React, { useEffect } from "react";

const TSPayCompletedPayment = props => {
  let hash = window.location.hash.split("?")[1];

  let result = hash.split("&").reduce(function(res, item) {
    var parts = item.split("=");
    res[parts[0]] = parts[1];
    return res;
  }, {});

  useEffect(() => {
    if (window && window.opener) {
      window.opener.postMessage(result, "*");
      window.close();
    }
  }, []);

  return <React.Fragment></React.Fragment>;
};

export default TSPayCompletedPayment;
